import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import QuestionFillIcon from "../../../../../media/images/icons/question-fill";
import ArrowDownSVG from "../../../../../media/images/icons/arrow-down";

export default function FaqCard() {
  const [open, setOpen] = useState(false);

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "info.light",
        borderRadius: "16px",
      }}
    >
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: 2,
          paddingY: 2,
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            gap: "8px",
          }}
        >
          <QuestionFillIcon color={theme.palette.primary.main} />
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            چرا بارنامه من لغو شده است؟چرا بارنامه من لغو شده است؟
          </Typography>
        </Box>
        <ArrowDownSVG color={theme.palette.primary.main} />
      </Box>

      <Box
        sx={{
          // border: "1px solid gray",
          transition: "all 0.5s",
          maxHeight: open ? "200px" : 0,
          overflow: "hidden",
          px: 2,
          py: open ? 1 : 0,
        }}
      >
        <Typography>
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده
          از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و
          سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای
          متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه
          درصد گذشته حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد
        </Typography>
      </Box>
    </Box>
  );
}
